"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var loading_spinner_scss_1 = tslib_1.__importDefault(require("./loading-spinner.scss"));
var Spinner = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement("div", { "data-hook": "loading-spinner-circle", className: (0, classnames_1.default)(className, loading_spinner_scss_1.default.circle) }));
};
Spinner.propTypes = {
    className: prop_types_1.default.string,
};
exports.default = Spinner;
//# sourceMappingURL=loading-spinner.js.map